import React, { Component } from 'react';
import AccesoSimultaneoItem from "./AccesoSimultaneoItem";

const AccesoSimultaneo = (props) => {

    let plataformas = props.plataformas.map(function (plataforma) {
        return (
            <div>
                <AccesoSimultaneoItem value={plataforma.CanLog} message={plataforma.Descripcion} />
            </div>         
        );       
    });

    return (
         <div class="row">
            <div>
                <h5 className="configuration-view-subtitle">Accesos máximos simultáneos por tipo de plataforma (default):</h5>
            </div>
        {plataformas}
         </div>
    );
};

export default AccesoSimultaneo;

